var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sendAuthCode)?_c('span',{staticClass:"ent-btntext",on:{"click":_vm.handleSend}},[_vm._v("获取验证码")]):_c('span',{staticClass:"ent-disable-btntext"},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b2bce54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/getMsgCode/getMsgCode.vue
// module id = null
// module chunks = 